import React from "react";
import { Flex, Box, Text, Heading } from "rebass";
import ProjectTitleListing from "../components/ProjectTitleListing";
import styled from "styled-components";
import Scene from "../components/Scene";
import Arrow from "../icons/Arrow";
import { AnchorLink } from "gatsby-plugin-anchor-links";

export default function Home() {
  let pathname = typeof window !== "undefined" ? window.location.pathname : "";
  const sectionUrl = pathname + "#home-projects";
  return (
    <main>
      <Flex flexWrap="nowrap" justifyContent="center">
        <Box order={[1, 0]} width={[1/1]}>
          <Flex flexWrap="wrap" alignItems="flex-end" variant="containerPage">
            <Box order={[2, 0]} width={[1 / 1]} mt={[0, 0, 0, 0, "-10.4rem"]}>
              <Heading as="h4" variant="catHeading">
                I'm Simona
              </Heading>
              <Text as="p" maxWidth="56.8rem" mb={[4]}>
                I design and work in (cross-functional) teams to achieve user
                experiences that are usable, scalable and lovable. Web and App.{" "}
                <strong>Across disciplines.</strong>
              </Text>
            </Box>
            <Box order={[1, 0]} mb={[0, 0, 4]} minHeight={["60vh","auto"]}>
              <Heading as="h1" variant="bigTitle" className="uppercase">
                UX &amp;
                <br />
                Eye Candy
              </Heading>
              <Text as="p" maxWidth="56.8rem" mt={[4]}>
                I design User Experiences, Design Systems and eCommerce
                Platforms. Below you can view some of my latest work.
              </Text>
            </Box>
            <Box order={[3, 0]} width={[1 / 1]} textAlign="center" mb={[3, 4]}>
              <StyledAnchorLink to={sectionUrl} title="My Contribution">
                <span>Case Studies</span>
                <Arrow />
              </StyledAnchorLink>
            </Box>
          </Flex>
        </Box>
        <CanvasWrapper order={[0, 1]} width={[1/1]}>
          <Scene />
        </CanvasWrapper>
      </Flex>
      <Flex flexWrap="wrap" alignItems="center" variant="container" my={[-4,-5]}>
        <Box width={[1 / 1]}>
          <Heading as="h4" variant="catHeading">
            Floppy Disks were a thing
          </Heading>
          <Text as="p" maxWidth="56.8rem">
            Since the beginning of my career, I have had one eye on visual
            design and the other on technology. For many years I was the one who
            delivered a website from the layouts to the production code.
          </Text>
        </Box>
      </Flex>
      <Box id="home-projects">
        <ProjectTitleListing />
      </Box>
    </main>
  );
}
const CanvasWrapper = styled(Box)`
  width: 100vw;
  height: 80vh;
  position: absolute;
  top: 24rem;
  @media only screen and (min-width: 52em) {
    height: 100vh;
  }
`;

const StyledAnchorLink = styled(AnchorLink)`
  position: relative;
  z-index: 99;
  & > span {
    display: block;
    opacity: 0;
    transition: opacity 0.1s ease-in-out;
    padding: 0.4rem;
  }
  ,
  &:hover span {
    opacity: 1;
  }
  ,
  & > svg,
  & > div > svg {
    width: 3.2rem;
    height: auto;
    transform: rotate(90deg);
  }
`;
